var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var Svg025ProtectiveGloves = function Svg025ProtectiveGloves(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 512 512"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M376 60v151h-30V30h-45v181h-30V0h-45v211h-30V30h-45v136.383c18.104 13.705 30 35.213 30 59.617v27.949c53.979 23.511 90 76.948 90 137.051v60h-90c-10.419 0-20.354-1.754-30-4.261V512h240V411.962c19.131-21.401 30-49.614 30-78.384V60z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M241 421v-30c0-55.853-38.333-102.376-90-115.757V226c0-24.853-20.147-45-45-45H91v150c0 49.706 40.294 90 90 90z"
  })));
};
export default Svg025ProtectiveGloves;